module.exports = __webpack_public_path__ + "media/content-creator/mobile-tech-3-87271348.png";